import React, { useState } from "react";
import Layout from "../components/Layout";
import Seo from "../components/Seo";
import { Mail, MessageCircle, Send } from "lucide-react";

export default function Contact() {
  const [sent, setSent] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    const data = new FormData(e.target);
    const subject = encodeURIComponent(`[Dompryce] ${data.get("subject") || "Hello"}`);
    const body = encodeURIComponent(
      `From: ${data.get("name")} <${data.get("email")}>\n\n${data.get("message")}`
    );
    window.location.href = `mailto:support@dompryce.com?subject=${subject}&body=${body}`;
    setSent(true);
  };

  return (
    <Layout>
      <Seo
        title="Contact Dompryce support"
        description="Reach the Dompryce team for support, registrar partnerships or press at support@dompryce.com. We reply within 1 business day."
        path="/contact"
      />
      <article className="mx-auto max-w-3xl py-8" data-testid="contact-page">
        <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-zinc-400">Contact</div>
        <h1 className="mt-2 font-display text-4xl font-bold tracking-tight text-zinc-900 md:text-5xl">
          Talk to a human at Dompryce.
        </h1>
        <p className="mt-4 text-lg text-zinc-600">
          Support questions, registrar partnerships, press enquiries — we'd love to hear from you.
        </p>

        <div className="mt-10 grid gap-6 md:grid-cols-2">
          <a
            href="mailto:support@dompryce.com"
            data-testid="contact-email-card"
            className="group rounded-2xl border border-zinc-100 bg-white p-6 transition-all hover:-translate-y-0.5 hover:border-indigo-200 hover:shadow-md"
          >
            <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-indigo-50 text-indigo-600">
              <Mail className="h-5 w-5" />
            </div>
            <div className="mt-4 font-display text-base font-semibold text-zinc-900">Email support</div>
            <div className="mt-1 text-sm text-zinc-600">Replies within 1 business day.</div>
            <div className="mt-3 font-mono text-sm font-medium text-indigo-600 group-hover:text-indigo-700">
              support@dompryce.com
            </div>
          </a>
          <div className="rounded-2xl border border-zinc-100 bg-white p-6">
            <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-emerald-50 text-emerald-600">
              <MessageCircle className="h-5 w-5" />
            </div>
            <div className="mt-4 font-display text-base font-semibold text-zinc-900">Office hours</div>
            <div className="mt-1 text-sm text-zinc-600">Mon – Fri · 9:00 – 18:00 IST</div>
            <div className="mt-3 text-xs text-zinc-500">
              We monitor email 7 days a week for urgent issues.
            </div>
          </div>
        </div>

        <form onSubmit={onSubmit} className="mt-10 rounded-2xl border border-zinc-100 bg-white p-6 md:p-8" data-testid="contact-form">
          <h2 className="font-display text-xl font-semibold text-zinc-900">Send us a message</h2>
          <div className="mt-6 grid gap-4 md:grid-cols-2">
            <label className="block">
              <span className="text-xs font-medium text-zinc-600">Your name</span>
              <input name="name" required className="mt-1 w-full rounded-lg border border-zinc-200 px-3 py-2 text-sm focus:border-indigo-400 focus:outline-none focus:ring-2 focus:ring-indigo-100" data-testid="contact-name" />
            </label>
            <label className="block">
              <span className="text-xs font-medium text-zinc-600">Email</span>
              <input name="email" type="email" required className="mt-1 w-full rounded-lg border border-zinc-200 px-3 py-2 text-sm focus:border-indigo-400 focus:outline-none focus:ring-2 focus:ring-indigo-100" data-testid="contact-email-input" />
            </label>
          </div>
          <label className="mt-4 block">
            <span className="text-xs font-medium text-zinc-600">Subject</span>
            <input name="subject" className="mt-1 w-full rounded-lg border border-zinc-200 px-3 py-2 text-sm focus:border-indigo-400 focus:outline-none focus:ring-2 focus:ring-indigo-100" data-testid="contact-subject" />
          </label>
          <label className="mt-4 block">
            <span className="text-xs font-medium text-zinc-600">Message</span>
            <textarea name="message" required rows={5} className="mt-1 w-full rounded-lg border border-zinc-200 px-3 py-2 text-sm focus:border-indigo-400 focus:outline-none focus:ring-2 focus:ring-indigo-100" data-testid="contact-message" />
          </label>
          <button
            type="submit"
            data-testid="contact-submit"
            className="mt-6 inline-flex items-center gap-2 rounded-xl bg-zinc-900 px-5 py-2.5 text-sm font-medium text-white hover:bg-zinc-800"
          >
            <Send className="h-4 w-4" /> {sent ? "Opening mail app…" : "Send message"}
          </button>
        </form>
      </article>
    </Layout>
  );
}
